import { registerArchetype } from './index.js';
import { livingEnemies, enemySide, getRuntimes } from '../combat.js';
registerArchetype({
    id: 'swap_position',
    apply: ({ state, source }) => {
        const enemies = livingEnemies(state, source.side);
        if (enemies.length < 2)
            return;
        const high = enemies.reduce((m, e) => e.runtime.hp > m.runtime.hp ? e : m);
        const low = enemies.reduce((m, e) => e.runtime.hp < m.runtime.hp ? e : m);
        if (high.slot === low.slot)
            return;
        const enemyKey = enemySide(source.side);
        const arr = getRuntimes(state, enemyKey);
        [arr[high.slot], arr[low.slot]] = [arr[low.slot], arr[high.slot]];
        const lineup = enemyKey === 'A' ? state.lineupA : state.lineupB;
        [lineup.slots[high.slot], lineup.slots[low.slot]] =
            [lineup.slots[low.slot], lineup.slots[high.slot]];
        state.events.push({
            t: state.tick, kind: 'status_apply',
            side: enemyKey, slot: high.slot,
            status: 'swap', duration: 0
        });
    }
});
